export const SET_PROJECTS = 'SET_PROJECTS';
export const setProjectsAction = (projects) => ({
  type: SET_PROJECTS,
  payload: projects,
});
